import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
// Material Imports
import { Grid } from '@material-ui/core';
//components
import ChapterCard from './Card';
//style
import './styles.scss';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
      {...other}
    >
      {value === index && <React.Fragment>{children}</React.Fragment>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

const CardLayout = props => {
  const chapterCardList = () => {
    const array = props.children;
    const list = [];
    array.map((data, index) => {
      let topicName = get(data, 'props.topic', '');
      list.push(
        <Grid item xs={6} sm={6} md={3} key={index}>
          <ChapterCard
            topic={topicName.substr(topicName.indexOf('|') + 1)}
            date={data.props.date}
            handler={data.props.handler}
            uniqueCode={data.props.uniqueCode}
            subject={props.subject}
            list={data.props.list}
            headerText={data.props.headerText}
            popupDisabled={data.props.popupDisabled}
          />
        </Grid>
      );
    });
    return list;
  };
  return (
    <TabPanel value={props.value} index={props.index} className="panel">
      <Grid container spacing={2} className="panel-body">
        {chapterCardList()}
      </Grid>
    </TabPanel>
  );
};
CardLayout.propTypes = {
  subject: PropTypes.string,
  children: PropTypes.array,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

export default CardLayout;
